// 各要素にbelongIdを付与（エクスポート時に必要）
// belongTypeは「oemId」「advertiserId」「insertionOrderId」のいずれか
const addBelongIdToPointGroup = (pointGroupList, belongType, belongId) => {
  if (
    belongType !== 'oem' &&
    belongType !== 'advertiser' &&
    belongType !== 'insertionOrder'
  ) {
    throw new Error('invalid belong Type')
  }
  const pointGroupListWithBelongId = pointGroupList.map(group => {
    group[belongType + 'Id'] = belongId
    return group
  })
  return pointGroupListWithBelongId
}

const findPointGroupsByOwnerProfileId = (pointGroupList, ownerProfileId) => {
  const ret = pointGroupList.filter(pointGroup => {
    return pointGroup.ownerProfileId !== ownerProfileId
  })
  return ret
}

const mutations = {
  SET_POINT_GROUP_LIST(state, { pointGroupList, belongType, belongId }) {
    const pointGroupListWithBelongId = addBelongIdToPointGroup(
      pointGroupList,
      belongType,
      belongId,
    )
    state.pointGroupList = [
      ...state.pointGroupList,
      ...pointGroupListWithBelongId,
    ]
  },
  REMOVE_POINT_GROUP_LIST(state, { ownerProfileId }) {
    const pointGroupList = findPointGroupsByOwnerProfileId(
      state.pointGroupList,
      ownerProfileId,
    )
    state.pointGroupList = pointGroupList
  },
  RESET_POINT_GROUP_LIST(state) {
    state.pointGroupList = []
  },
  SET_SELECTED_POINT_GROUP(state, { pointGroupId, isSelected }) {
    const pointGroupList = state.pointGroupList.map(pointGroup => {
      if (pointGroup.id === pointGroupId) {
        pointGroup.selected = isSelected
      }
      return pointGroup
    })
    state.pointGroupList = pointGroupList
  },
  SET_SELECTED_ALL_POINT_GROUP(state, { ownerProfileId, isSelected }) {
    const pointGroupList = state.pointGroupList.map(pointGroup => {
      if (pointGroup.ownerProfileId === ownerProfileId) {
        pointGroup.selected = isSelected
      }
      return pointGroup
    })
    state.pointGroupList = pointGroupList
  },
  SET_ALERT_MODAL_IS_SHOW(state, { isShow }) {
    state.alertModal.isShow = isShow
  },
}

export default mutations
